import React from "react";
import { strings } from "../../strings";
import Partners from "../Partners/Partners";
import styles from "./Footer.module.scss";

export default function Footer() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.links}>
        <div className={styles.copyright}>{strings.footerCopyright}</div>
        <div className={styles.linksWrapper}>
          <a
            href="https://www.iindy.co/terms-kidsinconflict"
            target="_blank"
            rel="noopener noreferrer"
          >
            {strings.footerTerms}
          </a>
          <a
            href="https://iindy.co/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {strings.footerPolicy}
          </a>
        </div>
      </div>
      <div className={styles.partners}>{/* <Partners /> */}</div>
    </div>
  );
}
